import { Reset } from "@/modules/auth/common/enum";
import { useAppSelector } from "@/shared/hooks";
import { FormField } from "@ab.uitools/ui-library/components/FormField";
import { Input } from "@ab.uitools/ui-library/components/Input";
import { useFormProps } from "@ab.uitools/ui-library/hooks/useFormProps";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export const UsernameVerificationFormFields = () => {
  const { t } = useTranslation();
  const { setValue, reset } = useFormProps();
  const resetFields = useAppSelector((state) => state.auth.reset);

  useEffect(() => {
    if (resetFields.username) {
      reset?.({ [Reset.Username]: "" });
      setValue(Reset.Username, resetFields.username);
    }
  }, [resetFields]);

  return (
    <FormField
      name={Reset.Username}
      className="mt-40"
      errorMessageIcon="infoFilled"
      As={(props) => (
        <Input
          {...props}
          required
          label={t("auth.usernameVerification.username")}
        />
      )}
    />
  );
};
